import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import AddIcon from "@material-ui/icons/Add";
import UiButton from "../../common/UiButton";
import { tableToolbarPrimaryButtonStyle } from "../../common/tableTheme";

const styles = (theme: Theme) =>
  createStyles({
    button: {
      padding: "9px 16px",
      minWidth: "250px",
    },
    buttonModern: tableToolbarPrimaryButtonStyle(theme),
    iconModern: {
      fontSize: 18,
    },
  });

interface PropsType {
  classes: any;
  toolbarVariant?: "default" | "modern";
}

const ProjectsActionButton: React.FC<PropsType> = (props) => {
  const { classes, toolbarVariant = "default" } = props;
  const isModern = toolbarVariant === "modern";

  return (
    <UiButton
      color="secondary"
      variant="contained"
      className={classNames({
        [classes.button]: !isModern,
        [classes.buttonModern]: isModern,
      })}
      to="/new_project"
      component={Link}
    >
      <AddIcon fontSize={isModern ? "small" : "default"} className={isModern ? classes.iconModern : undefined} />
      Nouveau projet
    </UiButton>
  );
};

export default withStyles(styles)(ProjectsActionButton);
